import { useEffect } from "react"
import { usePoliciesAccepted } from "@/hooks/usePoliciesAccepted"
import { useModals } from "@/modals"
import {
  INFO_MODAL_TYPES,
  useLazyGetInfoModalHasReadQuery
} from "@/store/apis/infoModalAPI"
import { useAppSelector } from "@/store/index"
import { AppSelectors } from "@/store/slices/app"

export const useCheckTutorial = () => {
  const { openModal } = useModals()

  const language = useAppSelector(AppSelectors.selectLanguage())
  const { allAccepted } = usePoliciesAccepted()

  const [getInfoModalHasRead] = useLazyGetInfoModalHasReadQuery()

  useEffect(() => {
    if (!allAccepted) return

    getInfoModalHasRead({
      type: INFO_MODAL_TYPES.TUTORIAL,
      lang: language
    }).then((res) => {
      if (res.data && !res.data.hasRead) {
        openModal("howItWorks")
      }
    })
  }, [allAccepted, language, getInfoModalHasRead, openModal])
}
